import styled from 'styled-components';
import { Body4, Headline2 } from './../../app/common/typography/index';

export const ForgotPasswordContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  margin-top: ${({ theme }) => theme.spacing.m};
  padding: 0 ${({ theme }) => theme.spacing.m};

  .phone-input-dropdown input[disabled] {
    background-color: ${({ theme }) => theme.colors.platinium};
  }

  .control-input:has(input[disabled]) {
    background-color: ${({ theme }) => theme.colors.platinium};
  }
`;

export const Title = styled(Headline2)`
  text-align: center;
`;

export const SubTitle = styled(Body4)`
  margin-bottom: ${({ theme }) => theme.spacing.xm};
  color: ${({ theme }) => theme.colors.dimGray};
`;

export const TextContainer = styled(Body4)`
  text-align: center;
  color: ${({ theme }) => theme.colors.dimGray};
`;

export const CTASection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing.l};
  row-gap: 10px;
  width: ${({ theme }) => theme.width.full};
`;

export const Body4Centered = styled(Body4)`
  text-align: center;
  color: ${({ theme }) => theme.colors.eerieBlack};
  margin-top: ${({ theme }) => theme.spacing.xm};
`;

export const TextModal = styled(Body4)`
  margin: ${({ theme }) => theme.spacing.md};
`;
